import React from 'react'
import { Button, Card, CircularProgress } from '@material-ui/core';
import axios from 'axios';
import './IpDocCard.scss';
import { envApiConfig } from '../shared/Links';
import { axiosDocumentInstance } from '../../actions/AxiosInstance';
import api from '../../actions/Endpoints';
import AppErrorAlert from '../AppErrorAlert/AppErrorAlert';


const IPDocCard = () => {

    const [isLoading, setisLoading] = React.useState(false);
    const [hover, setHover] = React.useState(null);
    const [open, setOpen] = React.useState(false);
    const onEnter = () => setHover(true);
    const onLeave = () => setHover(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    async function retrieveIp() {
        // eslint-disable-next-line no-console
        console.log('Calling retrieve historic IP');
        setisLoading(true);
        const loadKey = await axios.get(`${envApiConfig}`, {
            headers: { 'Application-Type': 'application/json' }
        });

        const { apiKey } = loadKey.data;
        try {
            const getIp = await axiosDocumentInstance.get(api.viewIpAPI(), {
                responseType: 'arraybuffer',
                headers: {
                    apikey: `${apiKey}`,
                    Accept: 'application/pdf',
                }
            });

            if (getIp) {
                const { data } = getIp;
                if (data !== undefined) {
                    const planBlob = new Blob([data], { type: 'application/pdf' });
                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                        // IE and Edge browser use msSaveOrOpenBlob
                        window.navigator.msSaveOrOpenBlob(planBlob, `Historic_IP_Page.pdf`);
                    } else {
                        try {
                            const link = document.createElement('a');
                            link.href = window.URL.createObjectURL(planBlob);
                            link.download = `Historic_IP_Page.pdf`;
                            link.click();
                            setTimeout(() => {
                                window.URL.revokeObjectURL(data);
                            }, 100);
                        } catch (e) {
                            handleOpen();
                            // eslint-disable-next-line no-console
                            console.log(e);
                        }
                    }
                }
            }
            setisLoading(false);
        } catch (err) {
            handleOpen();
            setisLoading(false);
            // eslint-disable-next-line no-console
            console.log(err);
        }
    }
    return (
        <>
            <AppErrorAlert
					dialogText='Client has not viewed the Investment Proposal Page yet.  Once they view this page, please retry.'
					onClickHandler={handleClose}
					dialogOpen={open}
					close={handleClose}
            />
        <Card>
            <div className='view-ip-container' style={{ display: "inline-flex" }}>
                <div className='viewIpDetail'>
                    <div>
                        Click the following button to see the most-recent historical IP Page
                    </div>
                    <div>
                        <Button
                            variant="outlined"
                            onClick={() => retrieveIp()}
                            onMouseEnter={onEnter}
                            onMouseLeave={onLeave}
                        >
                            View IP {' '}
                            {isLoading && React.cloneElement(
                                <CircularProgress
                                    size={20}
                                    id='loading-spinner'
                                    style={{
                                        color: '#05C3DE',
                                        marginLeft: '16px',
                                        verticalAlign: 'sub'
                                    }}
                                />, { filled: !!hover })}
                        </Button>
                    </div>
                </div>
            </div>
        </Card>
        </>
    )
}

export default IPDocCard;
